import { transformCurrencyAmountDto } from './currency-amount';
export const transformFeaturedCollectionPricing = dto => ({
  effectiveDays: dto.effective_days,
  totalPrice: transformCurrencyAmountDto(dto.total_price),
  pricePerDay: transformCurrencyAmountDto(dto.price_per_day)
});